<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 scrollTableNoTab">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @delete-items="deleteItems"
                            @new-item="openCreatePv"
                            @row-click="clickToRowItem"
                            @export="exportItems"
                            ref="gofixTable">
                            <template v-if="!checkSupplierUser()" slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-2 d-flex align-items-center filterCompany">
                                    <gofix-form-dropdown
                                        class="highlightDropdown chartOfAccountDropdown min-width-0 width-175"
                                        label=""
                                        vLabel="text"
                                        :clearable="false"
                                        :reduce="option => option.value"
                                        :options="optionsPlatform"
                                        v-model="platform"
                                        :placeholder="'Platform'">
                                    </gofix-form-dropdown>
                                </div>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:pv_date" slot-scope="row">
                                {{row.item.pv_date  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:amount" slot-scope="row">
                                {{ row.item.amount | formatMoney }}
                            </template>
                            <template slot="gofix_table:gst" slot-scope="row">
                                {{ row.item.gst | formatMoney }}
                            </template>
                            <template slot="gofix_table:total" slot-scope="row">
                                {{ row.item.total | formatMoney }}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true" id="modal-Create" title="payment voucher" hide-footer :centered="true" ref="modal-create-payment" v-model="modals.create.open">
                <b-form class="formInvoice">
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input-date
                                v-model="modals.create.data.pv_date"
                                required
                                label="PV date" />
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown label="Status"
                                :filterable="false"
                                :clearable="false"
                                :required="true"
                                v-model="modals.create.data.status"
                                desc="Please select a status"
                                :options="['Draft']" />
                        </b-col>
                        <b-col md="12">
                            <gofix-form-dropdown label="Pay to type"
                                vLabel="name"
                                :filterable="false"
                                :clearable="false"
                                :required="true"
                                v-model="modals.create.data.pay_to_type"
                                :options="modals.create.payTypes" />
                        </b-col>
                        <b-col md="12" v-if="modals.create.data.pay_to_type === 'Supplier'">
                            <gofix-form-supplier v-if="!checkSupplierUser()" label="Pay to"
                                :contract-id="modals.create.data.client_contract_id"
                                :required="true"
                                v-model="modals.create.data.pay_to" />
                            <gofix-form-dropdown v-else
                                label="Pay To"
                                vLabel="name"
                                :clearable="false"
                                :required="true"
                                :show-icon-required="true"
                                v-model="modals.create.data.pay_to"
                                :options="paytoOption">
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12" v-if="modals.create.data.pay_to_type === 'Manual'">
                            <gofix-form-dropdown label="Pay to"
                                vLabel="full_name"
                                :taggable="true"
                                :filterable="false"
                                :required="true"
                                v-model="modals.create.data.manual_pay_to"
                                :options="modals.create.manual.data" >
                              <template #gofixInput:dropdown:option="option">
                                {{option.id ? (option.id + ' - ' + option.full_name) : option.full_name}}
                              </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown label="Client Contract"
                                vLabel="contract_name"
                                :filterable="false"
                                :required="true"
                                @search="searchContract"
                                v-model="contract"
                                :options="modals.create.contract.data" />
                        </b-col>
                        <b-col md="6">
                            <gofix-form-dropdown label="Payment Mode"
                                :filterable="false"
                                :clearable="false"
                                :required="true"
                                v-model="modals.create.data.payment_mode"
                                :options="modals.create.payModes" />
                        </b-col>
                        <b-col md="12" v-if="modals.create.data.payment_mode === 'System Cheque' || modals.create.data.payment_mode === 'Manual Cheque'">
                            <gofix-form-input label="Cheque Number" v-model="modals.create.data.cheque_number"></gofix-form-input>
                        </b-col>
                        <b-col md="12">
                            <gofix-form-input label="Remarks" v-model="modals.create.data.remark"></gofix-form-input>
                        </b-col>
                        <b-col md="12" v-if="isShowCheckBoxNavision">
                            <div class="d-flex">
                                <b-form-checkbox v-model="modals.create.data.is_not_for_finance_posting" class="checkbox-pv-allow"><span class="ml-2">Not For Finance Posting</span></b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.payment_voucher, 'create')" >
                    <gofix-button label="SUBMIT" @click="savePayment" :loading="modals.create.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';
    import moment from 'moment';

    export default {
        name: 'payment-voucher',
        components: {},
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['payment_voucher']));
            return {
                tableConfig:{
                    name: 'payment-voucher-listing',
                    controls:{
                        create: this.$checkRole(this.$accessModule.payment_voucher, 'create'),
                        delete: this.$checkRole(this.$accessModule.payment_voucher, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                paytoOption:[],
                tableItems: [],
                contract:null,
                isShowCheckBoxNavision:true,
                modals:{
                    create:{
                        open:false,
                        loading:false,
                        data:{
                            pv_date: new Date(),
                            status: "Draft",
                            pay_to_id: null,
                            payment_mode: null,
                            cheque_number: null,
                            remark: null,
                            payment_amount: null,
                            pay_to: null,
                            manual_pay_to: null,
                            pay_to_type: "Supplier",
                            client_contract_id: this.ClientContractID ? this.ClientContractID.id : null,
                            is_not_for_finance_posting: false,
                        },
                        payTypes:["Supplier","Manual"],
                        payModes:['Electronic Transfer', 'System Cheque', 'Manual Cheque'],
                        suppliers:{
                            data: [],
                            timer:null
                        },
                        manual:{
                            data: [],
                            timer:null
                        },
                        contract:{
                            data: [],
                            timer:null
                        },
                        validate:false
                    }
                },
                platform: 'FM',
                optionsPlatform: [
                    {
                        value: 'FM',
                        text: 'GOfix FM'
                    },
                    {
                        value: 'LM',
                        text: 'GOfix LM'
                    },
                ]
            }
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.payment_voucher, 'create'),
                    delete: this.$checkRole(this.$accessModule.payment_voucher, 'delete')
                }
            },
            platform: function(val) {
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            "contract" : function(val){
                if(val && val.settings && val.settings.exclude_journal_entries_navision){
                    this.isShowCheckBoxNavision = false;
                    return;
                }
                this.isShowCheckBoxNavision = true;
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles',
                UserLogin: 'AuthController/user'
            })
        },
        created(){
            this.loadSuppliers();
            this.loadContract();
            this.loadManual();
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.platform = this.platform;
                await this.$store.dispatch("PaymentVoucherController/getPaymentVouchers", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('PaymentVoucherController/deletePaymentVoucher', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'payment_voucher'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            async clickToRowItem(item){
                return this.$router.push(`/v2/payment-voucher/${item.id}`)
            },

            /*-- Save data ----------------------*/
            savePayment() {
                this.modals.create.validate = true;
                if(!this.modals.create.data.pv_date
                ||!this.modals.create.data.status
                ||(this.modals.create.data.pay_to_type === "Supplier" && !this.modals.create.data.pay_to)
                ||(this.modals.create.data.pay_to_type === "Manual" && !this.modals.create.data.manual_pay_to)
                ||!this.contract
                ){
                    return this.$alertNotification("Please enter in the required fields", "danger");
                }
                this.modals.create.data.client_contract_id = this.contract && this.contract.id;
                this.modals.create.data.pv_date = moment(this.modals.create.data.pv_date).format("YYYY-MM-DD");
                this.modals.create.data.pay_to_id = this.modals.create.data.pay_to ? this.modals.create.data.pay_to.id : null;
                this.modals.create.loading = true;
                let object = Object.assign({}, this.modals.create.data);
                this.$store.dispatch(`PaymentVoucherController/createPayment`, object)
                    .then( response => {
                        this.modals.create.loading = false;
                        this.modals.create.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        return this.$alertNotification(this.$notificationV2('adding', 'payment_voucher'));
                    })
                    .catch(error => {
                        this.modals.create.loading = false;
                    });
            },

            /*-- Load data ----------------------*/
            loadSuppliers() {
                let filters = {
                    page: 1,
                    limit: 1000,
                    filter: {
                        is_supplier: true,
                    }
                }
                this.$store.dispatch('AccountSupplierController/getOrganizationsInPayment', filters)
                    .then(response => {
                        this.modals.create.suppliers.data = response.data.data.items;
                    })
                    .catch(error => {
                        console.log(error);
                        this.modals.create.suppliers.data = [];
                    })
            },
            searchSupplier(search, loading) {
                loading(true);
                if(this.modals.create.suppliers.timer) {
                    clearTimeout(this.modals.create.suppliers.timer);
                    this.modals.create.suppliers.timer = null;
                }
                this.modals.create.suppliers.timer = setTimeout(async () => {
                    try {
                        let response = await this.apiSearchSupplier(search);
                        if(response.data.status === 200) {
                            this.modals.create.suppliers.data = response.data.data.items
                            loading(false);
                        }
                    }
                    catch(error) {
                        this.modals.create.suppliers.data = []
                        loading(false);
                    }
                }, 500);
            },
            loadManual() {
                let filters = {
                    page: 1,
                    limit: -1
                };
                this.$store.dispatch('ManualPayToController/getItems', filters)
                    .then(response => {
                        this.modals.create.manual.data = response.items;
                    })
                    .catch(error => {
                        console.log(error);
                        this.modals.create.manual.data = [];
                    })
            },
            loadContract(){
                this.$store.dispatch('ContractController/getListClientContractsSearch', [1, null, 100])
                    .then(response => {
                        this.modals.create.contract.data = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                        this.modals.create.contract.data = [];
                    });
            },
            searchContract(search, loading){
                this.modals.create.contract.data = []
                loading(true);
                if(this.modals.create.contract.timer) {
                    clearTimeout(this.modals.create.contract.timer);
                    this.modals.create.contract.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$store.dispatch('ContractController/getListClientContractsSearch', [1, {contract_name: search }, 1000])
                        .then(response => {
                            this.modals.create.contract.data = response.data
                            loading(false)
                        })
                        .catch(err=>{ loading(false) })
                }, 500);
            },
            /*-- Attributes ----------------------*/
            openCreatePv(){
                this.modals.create.data = {
                    pv_date: new Date(),
                    status: "Draft",
                    pay_to_id: null,
                    payment_mode: null,
                    cheque_number: null,
                    remark: null,
                    payment_amount: '',
                    pay_to: null,
                    pay_to_type: "Supplier",
                    client_contract_id: this.ClientContractID ? this.ClientContractID.id : null,
                    is_not_for_finance_posting: false,
                };
                if(this.checkSupplierUser()){
                    this.modals.create.payTypes = ["Supplier"];
                    this.modals.create.data.pay_to = {
                        id: this.UserLogin && this.UserLogin.organisation_id,
                        name: this.UserLogin && this.UserLogin.organization && this.UserLogin.organization.name
                    };
                    this.paytoOption = [this.modals.create.data.pay_to];
                }
                this.modals.create.validate = false;
                this.modals.create.open = true;
            },
            apiSearchSupplier(search) {
                let filters = {
                    page: 1,
                    limit: 1000,
                    filter: {
                        is_supplier: true,
                        name: search || ''
                    }
                }
                return new Promise (( resolve, reject ) => {
                    this.$store.dispatch('AccountSupplierController/getOrganizationsInPayment', filters)
                        .then(response => { resolve(response) })
                        .catch(error => reject(error))
                })
            },
            exportItems(tableRequest) {
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                this.$store.dispatch( 'PaymentVoucherController/exportItems', request)
                .then(response => {
                    // let nameFile = `PaymentVoucher-${moment().format("DD-MMM-YYYY")}.zip`;
                    // if(response.headers["content-disposition"]) {
                    //     let arrTemp = response.headers["content-disposition"].split("filename=");
                    //     if(arrTemp[1]) {
                    //         nameFile = arrTemp[1].replaceAll('"', "");
                    //     }
                    // }
                    let nameFile = `ItemList.csv`;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nameFile); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
            },
            checkSupplierUser(){
                if(this.UserLogin.organization && this.UserLogin.organization.is_supplier)
                    return true;
                return false;
            }
        }
    }
</script>
